@if (statisticList$ | async; as statisticList) {
  <div class="d-flex flex-column h-100 modal-content">
    <apm-section-title icon="t_notes" title="{{ '446062' | apmTranslate }}"></apm-section-title>
    <mat-stepper class="stepper-content-modal-xl" #stepper [linear]="true" [(selectedIndex)]="selectedIndex">
      @for (group of statisticList; track group; let i = $index) {
        <mat-step [completed]="!!selectedStatistics[group.groupCode]" >
          <ng-template matStepLabel>{{ group.resourceId | apmTranslate }}</ng-template>
          <ng-template matStepContent>
            <apm-statistic-data-item
              [title]="group.resourceId | apmTranslate"
              [statisticDataList]="group.statistics ?? []"
              [groupCode]="group.groupCode"
              [selectedStatistics]="selectedStatistics"
              (selectedStatisticCodeChanged)="onStatisticSelected($event, group.groupCode)"
            ></apm-statistic-data-item>
          </ng-template>
        </mat-step>
      }
      <mat-step [completed]="allStepsCompleted">
        <ng-template matStepLabel>{{ 448725 | apmTranslate }}</ng-template>
        <ng-template matStepContent>
          <apm-section-title [title]="448725 | apmTranslate"></apm-section-title>
          @for (statistic of selectedStatistics | values; track statistic; let i = $index) {
            <div
              class="apm-card d-flex flex-row align-items-center shadow mb-3 cursor-pointer"
              (click)="setSelectedStep(i)"
              (mouseenter)="summaryHoverIndex = i"
              (mouseleave)="summaryHoverIndex = null"
            >
              @if (statistic?.icon) {
                <fa-icon class="d-block me-2" size="xl" [icon]="statistic!.icon"></fa-icon>
              }
              <div>{{ statistic?.resourceId | apmTranslate }}</div>
              <apm-icon
                icon="a_edit"
                class="ms-auto"
                size="sm"
                [active]="summaryHoverIndex === i"
              ></apm-icon>
            </div>
          }
        </ng-template>
      </mat-step>
    </mat-stepper>
    <div class="ms-auto mt-auto d-flex">
      @if (hasDatasheetMoreDetails) {
        <apm-button class="me-2" variant="secondary" (click)="skipAnswers(statisticList)">{{
          '446065' | apmTranslate
        }}</apm-button>
      }
      <apm-button class="me-2 min-w-sm" variant="secondary" [disabled]="stepper.selectedIndex === 0" (click)="goPrev()" >
        {{ '446066' | apmTranslate }}
      </apm-button>
      @if (stepper.selectedIndex !== statisticList.length) {
        <apm-button [disabled]="!stepper.selected?.completed" (click)="goNext()" class="min-w-sm">
          {{ '444727' | apmTranslate }}
        </apm-button>
      }
      @if (stepper.selectedIndex === statisticList.length) {
        <apm-button (click)="confirm()" class="min-w-sm" [disabled]="isConfirmDisabled">
          {{ '444735' | apmTranslate }}
        </apm-button>
      }
    </div>
  </div>
}
